module.exports = __webpack_public_path__ + "static/img/img5.33a6d1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/img5.jpg
// module id = 3bti
// module chunks = 0